import { motion } from 'framer-motion';

export function LandingMockPointer({
  visible,
  x,
  y,
  clicking = false,
  grabbing = false
}: {
  visible: boolean;
  x: number;
  y: number;
  clicking?: boolean;
  grabbing?: boolean;
}) {
  return (
    <motion.div
      className={[
        'lp-mock-pointer',
        grabbing ? 'lp-mock-pointer--grabbing' : '',
        clicking ? 'lp-mock-pointer--clicking' : ''
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
      initial={false}
      animate={{
        opacity: visible ? 1 : 0,
        left: x,
        top: y,
        scale: clicking ? 0.82 : grabbing ? 0.94 : 1
      }}
      transition={{
        opacity: { duration: 0.15 },
        scale: { type: 'spring', stiffness: 620, damping: 26 },
        left: { duration: 0 },
        top: { duration: 0 }
      }}
    />
  );
}
